import type { Lucid } from '../../types/types';
import { isRelativeURL, isAbsoluteURL } from '../guards';

export type FormatLanguagePrefix = {
  urlLangPrefix: Lucid.I18n.LanguagesURLPrefix;
  url: string;
};

const formatLanguagePrefix = ({
  urlLangPrefix,
  url,
}: FormatLanguagePrefix): Lucid.Generic.RelativeURL | Lucid.Generic.AbsoluteURL => {
  if (isRelativeURL(url)) {
    if (urlLangPrefix === '/') return url;

    return `${urlLangPrefix}${url}`;
  }

  if (isAbsoluteURL(url)) return url;

  if (urlLangPrefix === '/') return `/${url}` as Lucid.Generic.RelativeURL;

  return `${urlLangPrefix}/${url}`;
};

export default formatLanguagePrefix;
